import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setAccessDeleteError, setLoading } from "../../repository/slice";

function* deleteAllAccessWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, "/api/access/all", payload);
        if (isError) {
            yield put(setAccessDeleteError(message));
        } else {
            yield put(setAccessDeleteError(null));
        }
    } catch (error) {
        console.error("deleteAllAccessWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteAllAccessWatcher() {
    yield takeLatest("@saga/DELETE_ALL_ACCESS", deleteAllAccessWorker);
};